export interface MonthEndCloseViewParams {
    organizationId: string | null | undefined;
    hasCloseStages: boolean;
    hasCloses: boolean;
}

/** Close stages belong to the organization, so the Close stage column needs both. */
export const isCloseStageColumnShown = ({
    organizationId,
    hasCloseStages,
}: Pick<MonthEndCloseViewParams, "organizationId" | "hasCloseStages">) =>
    Boolean(organizationId && hasCloseStages);

/** Whether the workspace Tasks page lists Month-end close. */
export const isMonthEndCloseViewShown = (
    params: MonthEndCloseViewParams,
): boolean => isCloseStageColumnShown(params) && params.hasCloses;
